import { render, staticRenderFns } from "./PartidoDataCard.vue?vue&type=template&id=2ce79ddc&scoped=true&width=100&"
import script from "./PartidoDataCard.vue?vue&type=script&lang=js&"
export * from "./PartidoDataCard.vue?vue&type=script&lang=js&"
import style0 from "./PartidoDataCard.vue?vue&type=style&index=0&id=2ce79ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce79ddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VProgressLinear,
  VSubheader,
})
